<style>
.ivu-table .demo-table-info-row td {
    color: #19be6b;
}
</style>

<template>
    <div>

        <Card>
            <p slot="title"> Hapus Piutang </p>

            <Button-group v-show="receivables.length > 0 && accessRole" slot="extra">
                <Button type="error" icon="trash-b" @click="showDeleteAll" size="small" style="margin-right: 10px">
                    <span>Delete All</span>
                </Button>
            </Button-group>
            <Button-group slot="extra">
                <Button type="primary" :loading="loadingSearch" @click="getReceivables" icon="ios-search" size="small">
                    <span v-if="!loadingSearch">Search</span>
                    <span v-else>Wait.....</span>
                </Button>
            </Button-group>
            <Table v-show="receivables.length > 0" :columns="tableColumns" :data="receivables" no-data-text=""
                @on-row-click="showDeleteReceivable"></Table>


            <Modal v-model="modalConfirmDelete" width="500px" @on-cancel="confirmMarkingheadercode = ''">
                <p slot="header" style="color:#f60;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Konfirmasi</span>
                </p>
                <div style="text-align:left">
                    <h4>{{ receivableToDelete.markingheadercode }} : {{ receivableToDelete.transactionDate }}</h4>
                    <p>Keterangan : <br />{{ receivableToDelete.description }}</p>
                    <hr />
                    <p>Debit Amount : Rp <b>{{ receivableToDelete.debitAmount }} </b></p>
                    <br />
                    <p> Ketik <b>{{ receivableToDelete.markingheadercode }}</b> untuk Lanjut</p>
                    <br />
                    <Input v-model="confirmMarkingheadercode" />

                </div>
                <div slot="footer">

                    <Button type="error" size="large" long @click="deleteReceivable"
                        v-show="receivableToDelete.markingheadercode == confirmMarkingheadercode.toUpperCase()">Hapus
                    </Button>
                </div>
            </Modal>

        </Card>
    </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'
import { Money } from 'v-money'

const numeral = require('numeral');

export default {
    components: { Money },
    data: () => ({
        accessRole: false,
        confirmMarkingheadercode: '',
        modalConfirmDelete: false,
        modalConfirmDeleteAll: false,
        loadingSearch: false,
        user: {
            username: '',
            role: ''
        },
        modal: {
            deleteReceivable: false
        },
        markingIdSelected: '',
        markings: [],
        receivables: [],
        receivableToDelete: [],
        tableColumns: [
            {
                title: 'Tgl',
                key: 'transactionDate',
                sortable: false
            },
            {
                title: 'Marking',
                key: 'markingheadercode',
                sortable: true
            },
            {
                title: 'Keterangan',
                key: 'description',
                sortable: false
            },
            {
                title: 'Debit Amount',
                align: 'right',
                key: 'debitAmount',
                sortable: false
            }
        ]
    }),

    methods: {
        getReceivables: function () {
            let parent = this;
            this.loadingSearch = true;
            this.receivables = []
            HTTP
                .get('receivable/delete/show')
                .then(response => {
                    let receivables = []
                    _.forEach(response.data, function (value) {
                        let receivable = {
                            receivableId: value.id,
                            transactionDate: parent.showDateFormatted(value.transactionDate),
                            markingHeaderId: value.markingHeaderId,
                            markingheadercode: value.marking_minified.markingheadercode,
                            description: value.description,
                            debitAmount: numeral(value.debitAmount).format('0,0'),
                        }
                        receivables.push(receivable);
                    });
                    this.loadingSearch = false;
                    this.receivables = receivables;
                })
                .catch(e => {
                    this.loadingSearch = false;
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });
        },
        showDateFormatted: function (stringToFormat) {
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        showDeleteReceivable: function (receivableToDelete) {
            this.receivableToDelete = receivableToDelete
            this.modalConfirmDelete = true
        },
        deleteReceivable: function () {
            let receivableToDelete = this.receivableToDelete;

            HTTP
                .post('receivable/delete', {
                    receivableId: receivableToDelete.receivableId
                })
                .then(response => {
                    this.modalConfirmDelete = false
                    this.loadingPost = false

                    this.$Message.success({
                        content: 'Data Telah Terhapus',
                        duration: 4
                    });
                    console.log(response);
                    this.getReceivables();
                })
                .catch(e => {
                    this.modalConfirmDelete = false
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        showDeleteAll: function () {
            this.$Modal.confirm({
                title: 'Konfirmasi Delete All',
                content: '<p>Apakah Anda yakin ingin menghapus semua data piutang?</p>',
                onOk: () => {
                    this.deleteAllReceivables()
                }
            });
        },
        deleteAllReceivables: function () {
            let parent = this;
            console.info(this.receivables)
            const deletePromises = this.receivables.map(function (receivable) {
                return HTTP.post('receivable/delete', {
                    receivableId: receivable.receivableId
                });
            });

            Promise.all(deletePromises)
                .then(responses => {
                    this.modalConfirmDeleteAll = false;
                    this.loadingPost = false;

                    this.$Message.success({
                        content: 'Semua Data Telah Terhapus',
                        duration: 4
                    });

                    console.log(responses);
                    parent.getReceivables();
                })
                .catch(e => {
                    this.modalConfirmDeleteAll = false;
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                    parent.getReceivables();
                });
        }
    },
    created() {
        this.user.role = localStorage.getItem('user.role')
        this.accessRole = this.user.role == 'ADMINISTRATOR' || this.user.role == 'SUPERVISOR'
    }
}

</script>



// WEBPACK FOOTER //
// ReceivableDelete.vue?5fd4f862